import { CalendarioMensal } from "@/components/CalendarioMensal";

export function Calendario() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-slate-900">Calendário de Turnos</h1>
      <CalendarioMensal />
    </div>
  );
}
